import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Founder from './components/Founder';
import HomeEvents from './components/HomeEvents';
import Teachings from './components/Teachings';
import Life from './components/Life';
import WhyChoose from './components/WhyChoose';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import EventsPage from './components/Events';
import VedaGurukulam from './components/VedaGurukulam';
import ContactUs from './components/ContactUs';
import Blog from './components/Blog';
// import LaunchPopup from './components/LaunchPopup';
import ScrollToTop from './components/ScrollToTop';

// Home Page Component - Updated to use HomeEvents
const HomePage = () => {
  return (
    <>
      <Hero />
      <Founder />
      <About />
      <HomeEvents />
      <Teachings />
      <Life />
      <WhyChoose />
      <Testimonials />
      <Contact />
    </>
  );
};

function App() {
  // const [showPopup, setShowPopup] = useState(false);

  // useEffect(() => {
  //   // Check if this is a new visit (not a refresh)
  //   const isNewVisit = !sessionStorage.getItem('visitedBefore');
  //   
  //   if (isNewVisit) {
  //     setShowPopup(true);
  //     // Mark as visited for this session
  //     sessionStorage.setItem('visitedBefore', 'true');
  //   }
  // }, []);

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };

  return (
    <Router>
      <div className="App">
        {/* Scroll to top on route change */}
        <ScrollToTop />
        
        {/* Launch Popup */}
        {/* <LaunchPopup isOpen={showPopup} onClose={handleClosePopup} /> */}
        
        {/* Main Website Content */}
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/veda-gurukulam" element={<VedaGurukulam />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
